import { render, staticRenderFns } from "./ProcessingStation.vue?vue&type=template&id=eba6c6ba&scoped=true&"
import script from "./ProcessingStation.vue?vue&type=script&lang=js&"
export * from "./ProcessingStation.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingStation.vue?vue&type=style&index=0&id=eba6c6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba6c6ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
